import { CdkColumnDef } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { AppCommonModule } from '../../../app-common.module';
import { SupplyChainDirectCommonModule } from '../supply-chain-direct-common.module';
import { BusinessUnitsSelectPageHeaderComponent } from './business-units-select-page-header.component';
import { AccountInvoicesComponent } from './invoices/invoices.component';
import { RevokeInvoiceModalComponent } from './invoices/revoke-invoice-modal/revoke-invoice-modal.component';
import { AccountBusinessUnitsTableComponent } from './overview/business-units-table/business-units-table.component';
import { AccountCreditSummaryTileComponent } from './overview/credit-summary-tile/credit-summary-tile.component';
import { BuyerEarlyPaymentTableComponent } from './overview/early-payment-table/early-payment-table.component';
import { AccountInvoiceSummaryTileComponent } from './shared/invoice-summary-tile/invoice-summary-tile.component';
import { HighChartComponent } from './shared/lsq-high-charts/lsq-high-charts';
import { BuyerInvoicesPayableTableComponent } from './overview/invoices-payable-table/invoices-payable-table.component';
import { BuyerAccountOverviewComponent } from './overview/overview.component';
import { AccountPaymentsSummaryTileComponent } from './overview/payment-summary-tile/payment-summary-tile.component';
import { AccountSupplierSummaryTileComponent } from './overview/supplier-summary-tile/supplier-summary-tile.component';
import { SupplierBasicInformationComponent } from './suppliers/supplier-details/supplier-basic-information.component';
import { SupplierDetailsOpenInvoicesTile } from './suppliers/supplier-details/supplier-details-open-invoices.component';
import { SupplierDetailsComponent } from './suppliers/supplier-details/supplier-details.component';
import { SuppliersDataSourceService } from './suppliers/suppliers-data-source.service';
import { AccountSuppliersComponent } from './suppliers/suppliers.component';
import { SupplyChainDirectAccountComponent } from './supply-chain-direct-account.component';
import { SupplyChainDirectAccountService } from './supply-chain-direct-account.service';
import { BuyerAccountInvoiceUploadModalComponent } from './upload/buyer-account-upload-modal/buyer-account-invoice-upload-modal.component';
import { BuyerAccountRemittanceInstructionsUploadModalComponent } from './upload/buyer-account-upload-modal/buyer-account-remittance-upload-modal.component';
import { BuyerAccountRoutingInstructionsUploadModalComponent } from './upload/buyer-account-upload-modal/buyer-account-routing-instruction-upload-modal.component';
import { BuyerAccountSupplierUploadModalComponent } from './upload/buyer-account-upload-modal/buyer-account-supplier-upload-modal.component';
import { BuyerAccountUploadButtonComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-button.component';
import { BuyerAccountUploadModalComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-modal.component';
import { BuyerAccountInvoiceUploadSuccessModalComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-success-modal/buyer-account-invoice-upload-success-modal.component';
import { BuyerAccountRemittanceInstructionsUploadSuccessModalComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-success-modal/buyer-account-remittance-instructions-upload-success-modal.component';
import { BuyerAccountRoutingInstructionsUploadSuccessModalComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-success-modal/buyer-account-routing-instructions-upload-success-modal.component';
import { BuyerAccountSupplierUploadSuccessModalComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-success-modal/buyer-account-supplier-upload-success-modal.component';
import { BuyerAccountUploadSuccessModalComponent } from './upload/buyer-account-upload-modal/buyer-account-upload-success-modal/buyer-account-upload-success-modal.component';
import { SupplierProgramInformationComponent } from './suppliers/supplier-details/supplier-program-information.component';
import { SupplierContactsTableComponent } from './suppliers/supplier-details/supplier-contacts.component';
import { AccountParentGroupedInvoiceDetailPageComponent } from './invoices/parent-grouped-invoice-detail/parent-grouped-invoice-detail.component';
import { AccountPendingCreditMemosComponent } from './invoices/pending-credit-memos/pending-credit-memos.component';
import { BuyerAccountPaymentsComponent } from './payments/payments.component';
import { BuyerAccountInvoiceDetailCardComponent } from './invoice-detail-page/invoice-detail-card/invoice-detail-card.component';
import { BuyerAccountInvoiceDetailPageComponent } from './invoice-detail-page/invoice-detail-page.component';
import { GroupedInvoiceDetailPageComponent } from './invoice-detail-page/grouped-invoice-detail-page.component';
import { BuyerAccountInvoicePaymentDetailCardComponent } from './invoice-detail-page/invoice-payment-detail-page/invoice-payment-detail-card.component';
import { RequestPayLaterPageComponent } from './request-pay-later-page/request-pay-later-page.component';
import { LsqFormsModule } from '@lsq-frontend/common-ui';
import { PayLaterAmountClusterComponent } from './request-pay-later-page/pay-later-amount-cluster/pay-later-amount-cluster.component';
import { RequestPayLaterConfirmationModalComponent } from './request-pay-later-page/request-pay-later-confirmation-modal/request-pay-later-confirmation-modal.component';
import { FacilityUtilizationTileComponent } from './overview/facility-utilization-tile/facility-utilization-tile.component';
import { FacilityUtilizationFtTileComponent } from './overview/facility-utilization-ft-tile/facility-utilization-ft-tile.component';
import { AccountSpendVolumeTileComponent } from './overview/spend-volume-tile/spend-volume-tile.component';
import { ChartSupplierDetailsComponent } from './shared/lsq-high-charts/chart-supplier-details/chart-supplier-details';
import { FlexTermAvailabilityTileComponent } from './overview/flex-term-availability-tile/flex-term-availability-tile.component';
import { AgingSummarySCFComponent } from './overview/aging-summary/aging-summary-scf.component';

const sharedComponents = [
    BusinessUnitsSelectPageHeaderComponent,

    BuyerAccountOverviewComponent,
    AccountInvoiceSummaryTileComponent,
    HighChartComponent,
    ChartSupplierDetailsComponent,
    AccountPaymentsSummaryTileComponent,
    AccountSupplierSummaryTileComponent,
    AccountCreditSummaryTileComponent,
    AccountInvoicesComponent,
    BuyerAccountPaymentsComponent,
    AccountSuppliersComponent,
    AccountSpendVolumeTileComponent,
    AccountPendingCreditMemosComponent,
    AccountBusinessUnitsTableComponent,
    BuyerInvoicesPayableTableComponent,
    BuyerEarlyPaymentTableComponent,

    BuyerAccountUploadButtonComponent,
    BuyerAccountInvoiceUploadSuccessModalComponent,
    BuyerAccountRemittanceInstructionsUploadSuccessModalComponent,
    BuyerAccountRoutingInstructionsUploadSuccessModalComponent,
    BuyerAccountSupplierUploadSuccessModalComponent,
    BuyerAccountUploadSuccessModalComponent,
    BuyerAccountInvoiceUploadModalComponent,
    BuyerAccountRemittanceInstructionsUploadModalComponent,
    BuyerAccountRoutingInstructionsUploadModalComponent,
    BuyerAccountSupplierUploadModalComponent,
    BuyerAccountUploadModalComponent,
    RevokeInvoiceModalComponent,
    BuyerEarlyPaymentTableComponent,
    AccountParentGroupedInvoiceDetailPageComponent,
    BuyerAccountInvoiceDetailCardComponent,
    BuyerAccountInvoiceDetailPageComponent,
    BuyerAccountInvoicePaymentDetailCardComponent,
    GroupedInvoiceDetailPageComponent,

    SupplierDetailsComponent,
    SupplierBasicInformationComponent,
    SupplierDetailsOpenInvoicesTile,
    SupplierContactsTableComponent,
    SupplierProgramInformationComponent
];
@NgModule({
    imports: [
        LsqCommonModule.forChild(),
        LsqTablesModule.forRoot(),
        LsqFormsModule,
        AppCommonModule,
        SupplyChainDirectCommonModule
    ],
    declarations: [
        SupplyChainDirectAccountComponent,
        RequestPayLaterPageComponent,
        PayLaterAmountClusterComponent,
        RequestPayLaterConfirmationModalComponent,
        AgingSummarySCFComponent,
        FacilityUtilizationTileComponent,
        FacilityUtilizationFtTileComponent,
        FlexTermAvailabilityTileComponent,
        ...sharedComponents
    ],
    exports: [...sharedComponents],
    providers: [CdkColumnDef, SupplyChainDirectAccountService, SuppliersDataSourceService]
})
export class SupplyChainDirectBuyerAccountModule {}
